import script from "./TitheAndOfferings.vue?vue&type=script&setup=true&lang=js"
export * from "./TitheAndOfferings.vue?vue&type=script&setup=true&lang=js"

import "./TitheAndOfferings.vue?vue&type=style&index=0&id=48af2893&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48af2893"]])

export default __exports__